<template>
  <div :class="`popup popup_wizard workflow-selector-popup d-print-none ${isOpen ? 'opened' : ''}`">
    <div :class="`popup-data ${isOpen ? 'opened' : ''}`">
      <div class="popup-header" v-text="title"/>

      <div class="popup-inner">
        <choose-type
          :workflow-details="workflowDetails"
          v-model="model"
          @save="onSave"
          @cancel="onCancel"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ChooseType from "./chooseType.vue";
import { cloneDeep } from "lodash";

export default {
  components: {
    ChooseType
  },

  props: {
    title: { type: String, required: true },

    physicalFlowImageTitle: { type: String, required: true },
    physicalFlowImage: { type: String, required: true },
    physicalFlowImageDescription: { type: String, required: true },
    digitalFlowImageTitle: { type: String, required: true },
    digitalFlowImage: { type: String, required: true },
    digitalFlowImageDescription: { type: String, required: true },
  },

  data() {
    return {
      value: null,
      isOpen: false,
    }
  },

  mounted() {
    this.$eventBus.$on('open:choose-workflow-modal', this.openModal);
    this.$eventBus.$on('close:choose-workflow-modal', this.closeModal);
  },

  beforeDestroy() {
    this.$eventBus.$off('open:choose-workflow-modal');
    this.$eventBus.$off('close:choose-workflow-modal');
  },

  computed: {
    model: {
      get() {
        return [cloneDeep(this.value)];
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    },

    workflowDetails() {
      return {
        physical: {
          type: 'physical',
          title: this.physicalFlowImageTitle,
          description: this.physicalFlowImageDescription,
          image: this.physicalFlowImage,
        },
        digital: {
          type: 'digital',
          title: this.digitalFlowImageTitle,
          description: this.digitalFlowImageDescription,
          image: this.digitalFlowImage,
        }
      }
    },
  },

  methods: {
    openModal({value}) {
      this.value = value;
      this.isOpen = true;
    },

    closeModal() {
      this.isOpen = false;
    },

    onSave(codes) {
      this.$eventBus.$emit('codes:update', codes);
      this.closeModal();
    },

    onCancel() {
      this.isOpen = false;
    }
  }
}
</script>
